module.exports = __webpack_public_path__ + "img/ball_5_green.020361bd.png";